const tasksEs = {
  my_tasks: "Mis Tareas",
  open_tasks_awaiting_action:
    "{{count}} tareas de flujo de trabajo abiertas esperando tu acción",
  refresh: "Actualizar",
  search_by_task_type: "Filtrar por acción",
  search_by_entity_type: "Filtrar por tipo de entidad",
  task_type_approval: "Aprobación",
  task_type_update_document: "Actualizar documento",
  task_type_queries: "Consultas",
  entity_type_purchase_invoice: "Factura de compra",
  entity_type_supplier: "Proveedor",
  entity_type_purchase: "Requisiciónes de compra",
  search_by_status: "Filtrar por estado",
  pending_tasks: "Tareas pendientes",
  completed_tasks: "Tareas completadas",
  more_count: "+{{count}} más",
  more_actions: "Más acciones",
  view_and_ask_queries: "Ver y hacer consultas",
  view_connected_workflow: "Ver flujo de trabajo conectado",
  connected_workflow: "Flujo de trabajo conectado",
  no_history_yet: "Aún no hay historial",
  finished_by: "Finalizado por {{details}}",
  assigned_to: "Asignado a {{details}}",
  description: "Descripción",
  status: "Estado",
  actions: "Acciones",
  entity_details: "Detalles de la Entidad",
  reason: "Motivo",
  reason_is_required: "El motivo es obligatorio",
  reason_max_length_validation: "El motivo no puede exceder los 100 caracteres",
  approve_task: "Aprobar Tarea",
  reject_task: "Rechazar Tarea",
  approve: "Aprobar",
  reject: "Rechazar",
  review_document: "Revisar Documento",
  review_supplier: "Revisar Proveedor",
  ask_query: "Hacer una consulta",
  raise_query: "Plantear consulta",
  raise_query_subtitle: "Haz una pregunta a otro rol de este flujo de trabajo",
  submit: "Enviar",
  answer_query: "Responder consulta",
  answer_query_subtitle: "Puedes simplemente responder la consulta",
  your_answer: "Tu respuesta",
  enter_answer: "Ingresa la respuesta",
  answer: "Responder",
  question: "Pregunta",
  enter_question: "Describe tu consulta...,",
  organization_role: "Rol de la organización",
  select_organization_role: "Selecciona el rol de la organización",
  stage: "Etapa",
  stage_optional: "Etapa (Opcional)",
  select_stage: "Selecciona la etapa",
  answer_is_required: "La respuesta es obligatoria",
  answer_max_length_validation:
    "La respuesta no puede exceder los 1000 caracteres",
  question_is_required: "La pregunta es obligatoria",
  question_max_length_validation:
    "La pregunta no puede exceder los 1000 caracteres",
  organization_role_is_required: "El rol de la organización es obligatorio",
  stage_is_required: "La etapa es obligatoria",
  query_raised_successfully: "Consulta planteada exitosamente",
  query_answered_successfully: "Consulta respondida exitosamente",
  task_completed_successfully: "Tarea completada exitosamente",
  no_tasks_title: "No se encontraron tareas",
  no_tasks_description: "No tienes tareas abiertas en este momento.",
  view_task_queries: "Ver consultas de la tarea",
  ask_a_query: "Hacer una consulta",
  add_an_answer: "Añade una respuesta",
  asked_a_query: "{{email}} hizo una consulta",
  user_on_date: "{{by}} el {{date}}",
  no_queries_yet: "Aún no hay consultas",
  no_answers_yet: "Aún no hay respuestas",
  answers: "Respuestas",
  taskQueries: "Consultas de la tarea",
  allQueries: "Todas las consultas",
  Open: "Abierta",
  Closed: "Cerrada",
  Answered: "Respondida",
  Pending: "Pendiente",
  InProgress: "En Progreso",
  Completed: "Completada",
  please_provide_a_reason: "Proporciona un motivo al aprobar el documento",
  provide_reason_when_rejecting_document:
    "Proporciona un motivo al rechazar el documento",
  all_queries_previously_asked:
    "Todas las consultas formuladas previamente en relación con esta tarea.",
  needs_review: "Necesita Revisión",
  needs_approval: "Necesita Aprobación",
  post: "Publicar",
  discard: "Descartar",
  close: "Cerrar",
  discard_task: "Descartar Tarea",
  close_task: "Cerrar Tarea",
  provide_reason_when_discarding_task:
    "Proporciona un motivo para descartar esta tarea",
  provide_reason_when_closing_task:
    "Proporciona un motivo para cerrar esta tarea",
  review_purchase_requisition: "Revisar Solicitud de Compra",
  review_pr: "Revisión (PR)",
  create_po: "Crear OC",
  create_purchase_order: "Crear Orden de Compra",
  send_query_to: "Enviar a",
  send_to_role: "Rol",
  send_to_user: "Usuario",
  select_user: "Seleccionar usuario",
  user_is_required: "El usuario es obligatorio",
  task_source: "Origen",
  task_source_query: "Consulta",
  task_source_manual: "Manual",
  pending_task_count: "Pendiente Tareas ({{count}})",
  pending_tasks_dialog_subtitle: "Tareas pendientes de acción en este documento",
  assigned_to_role: "Asignado a: {{role}}",
  assigned_to_users: "Asignado a: {{users}}",
  task_query_on_task: "Consulta planteada en otra tarea",
  no_pending_tasks: "No hay tareas pendientes",
  workflow_tasks: "Tareas del flujo de trabajo",
  workflow_tasks_dialog_subtitle: "Todas las tareas creadas en este documento",
  workflow_task_count: "Tareas ({{count}})",
  no_workflow_tasks: "No se encontraron tareas",
  completed_by_user: "Completada por {{user}}",
  closed_by_user: "Cerrada por {{user}}",
  closed_reason: "Motivo: {{reason}}",
  completion_details: "Detalles de finalización",
  closure_details: "Detalles de cierre",
  completed_by: "Completada por",
  closed_by: "Cerrada por",
  email: "Correo electrónico",
  completed_on: "Completada el",
  closed_on: "Cerrada el",
  task_action_pending_approval: "Pendiente de aprobación",
  task_action_review_document: "Revisar documento",
  task_action_query: "Consulta",
  task_action_finalize: "Pendiente de decisión final",
  task_action_review_pr: "Revisar requisición de compra",
  task_action_create_po: "Crear orden de compra",
  task_action_review_supplier: "Revisar proveedor",
  workflow_doc_still_unclassified: "Este documento aún no está clasificado. Clasifícalo antes de continuar con el flujo de trabajo",
  role: "Rol",
  assigned_to_label: "Asignado a",
  close_query: "Cerrar consulta",
  query_closed_successfully: "Consulta cerrada exitosamente",
  pending_queries_count: "{{count}} consultas pendientes",
  supplier_warning_not_attached:
    "No hay ningún proveedor asociado. Introduce una dirección de correo electrónico.",
  supplier_warning_onboarding_pending:
    "La incorporación del proveedor no está completa. La consulta se enviará solo por correo electrónico.",
  supplier_warning_email_missing:
    "El proveedor no tiene dirección de correo electrónico. Añade una al proveedor antes de enviar una consulta.",
  supplier_warning_not_found: "No se pudo encontrar el proveedor asociado.",
  recipient_emails: "Correo(s) del destinatario",
  query_sent_to: "La consulta se enviará a",
  recipient_emails_placeholder: "Escribe un correo y pulsa Enter (máx. {{max}})",
  recipient_emails_required: "Se requiere al menos una dirección de correo electrónico.",
  recipient_email_invalid: "Dirección de correo electrónico no válida: {{value}}.",
  recipient_emails_max: "Se permite un máximo de {{max}} direcciones de correo electrónico.",
  provide_reason_when_closing_query: "Proporciona un motivo para cerrar esta consulta",
  send_to_supplier: "Proveedor",
  // Connected workflow — Upcoming
  history: "Historial",
  upcoming: "Próximos",
  next: "Siguiente",
  possible: "Posible",
  one_of_these: "Uno de estos",
  workflow_may_end: "O el flujo de trabajo puede finalizar",
  may_repeat: "Puede repetirse",
  may_be_skipped: "Puede omitirse",
  upcoming_condition: "Si {{parameter}} {{operation}} {{value}}",
  no_upcoming_steps: "No hay próximos pasos",
  assignee_source_entity_manager: "Responsable del propietario de la entidad",
  assignee_source_task_manager: "Responsable de la tarea",
  // All Tasks
  tasks: "Tareas",
  all_tasks: "Todas las tareas",
  no_permission_all_tasks: "No tienes permiso para ver todas las tareas.",
  org_tasks_count: "{{count}} tareas en tu organización",
  no_org_tasks_description: "Ninguna tarea coincide con los filtros seleccionados.",
  add_filter: "Añadir filtro",
  all: "Todos",
  filter_tasks: "Filtrar tareas",
  filter_tasks_subtitle: "Acota las tareas de la organización",
  sort_by: "Ordenar por",
  sort_newest_first: "Más recientes primero",
  sort_longest_waiting: "Mayor tiempo de espera",
  Discarded: "Descartada",
  origin_template: "Plantilla",
  origin_manual: "Manual",
  origin_query: "Consulta",
  assignment_type: "Tipo de asignación",
  assignment_type_role: "Rol",
  assignment_type_user: "Usuario",
  assignment_type_supplier: "Proveedor",
  entity_type: "Tipo de entidad",
  task_action: "Acción",
  created_by_system: "Sistema",
  created_by_user: "Usuario",
  column_task: "Tarea",
  column_origin: "Origen",
  column_waiting: "En espera",
  column_created_by: "Creada por",
  column_previous_step: "Paso anterior",
  no_assignee: "Sin responsable",
  waiting_days: "{{count}} días",
  raised_on_task: "Planteada sobre {{action}}",
};

export default tasksEs;
